import { Injectable } from '@angular/core';

export interface IZoomControllerState {
    panEnabled: boolean;
    remoteControlEndedUnbind: Function;
    autoZoomed: boolean;
}

export interface IZoomControllerService {
    transfer: (deviceId: string, zoomControllerService: IZoomControllerService) => void;
    setState: (state: IZoomControllerState, deviceId: string) => void;
    getState: (deviceId: string) => IZoomControllerState;
    resetState: (deviceId: string) => void;
}

class DeviceIdToZoomControllerStateMap {
    [deviceId: string]: IZoomControllerState
}

class ZoomControllerState implements IZoomControllerState {
    panEnabled: boolean;
    remoteControlEndedUnbind: Function;
    autoZoomed: boolean;

    constructor() {
        this.panEnabled = false;
        this.remoteControlEndedUnbind = null;
        this.autoZoomed = true;
    }
}

@Injectable()
export class ZoomControllerService implements IZoomControllerService {
    private states: DeviceIdToZoomControllerStateMap;

    constructor() {
        this.states = new DeviceIdToZoomControllerStateMap();
    }

    public setState = (state: IZoomControllerState, deviceId: string) => {
        this.states[deviceId] = state;
    };

    public getState = (deviceId: string): IZoomControllerState => {
        const keys = Object.keys(this.states);
        for (const key of keys) {
            if (key === deviceId || key.endsWith(deviceId) || deviceId.endsWith(key)) {
                return this.states[key];
            }
        }
        const state = new ZoomControllerState();
        this.states[deviceId] = state;
        return state;
    };

    public resetState = (deviceId: string) => {
        const state: IZoomControllerState = this.states[deviceId];
        if (state) {
            delete this.states[deviceId];
        }
    };

    public transfer = (deviceId: string, zoomControllerService: IZoomControllerService) => {
        const oldState = zoomControllerService.getState(deviceId);
        this.setState(oldState, deviceId);
    };
}
